import React, { forwardRef, useEffect, useImperativeHandle, useState } from "react";
import { TripleDatePicker } from "@fidget/common/components/form/tripleDatePicker/tripleDatePicker";
import { DeleteCrossIcon } from "@fidget/common/components/icons/deleteCrossIcon/DeleteCrossIcon";
import tripleDatePickerStyles from "./tripleDatePickerWithLabel.css";

type OwnProps = { label: string; handleClear: () => void };
type Props = OwnProps & Omit<React.ComponentProps<typeof TripleDatePicker>, "initiallyOpen">;

export interface DatePickerRef {
  reset(): void;
}

export const TripleDatePickerWithLabel = forwardRef<DatePickerRef, Props>(
  ({ label, handleClear, ...tripleDatePickerProps }, ref) => {
    const [key, setKey] = useState(Math.random());

    useImperativeHandle<DatePickerRef | undefined, DatePickerRef>(
      ref,
      () => ({
        reset: () => setKey(Math.random())
      }),
      []
    );

    useEffect(() => {
      if (tripleDatePickerProps.initialChoice === undefined) {
        setKey(Math.random());
      }
    }, [tripleDatePickerProps.initialChoice]);

    return (
      <>
        <div className={tripleDatePickerStyles["time-valid-label"]}>{label}</div>
        <div className={tripleDatePickerStyles.container}>
          <TripleDatePicker key={key} {...tripleDatePickerProps} initiallyOpen={false} />

          <DeleteCrossIcon onClick={handleClear} className={tripleDatePickerStyles["reset-icon"]} />
        </div>
      </>
    );
  }
);
